<template lang="pug">
.v-mortgage.mortgage(v-if="data")
	.container
		.mortgage__inner
			h1.mortgage__title(v-if="data.title") {{data.title}}
			.mortgage__items(v-if="data.items && data.items.length")
				.mortgage__item(v-for="(item, idx) in data.items" :key="idx")
					.mortgage__item-top
						a.mortgage__logo(v-if="item.logo" :href="item.logo?.href")
							img.mortgage__logo-icon(:src="item.logo.src" :alt="item.logo.alt")
						.mortgage__info
							.mortgage__item-title(v-if="item.title") {{item.title}}
							.mortgage__item-subtitle(v-if="item.subtitle") {{item.subtitle}}
							.mortgage__item-links(v-if="item.links")
								a.mortgage__item-link(v-for="(link, indx) in item.links" :class="link.className" :key="indx" :href="link.link") {{link.text}}
					.mortgage__content(v-if="item.content" :style="{backgroundColor: item.content.backgroundColor}" v-html="item.content.text")
					a.mortgage__link.btn(v-if="item.button" :href="item.button?.href") {{ item.button?.text }}
			.mortgage__slider(v-if="data.adSlider" )
				v-section-slider(:data-source="data.adSlider" template="ad" :options="adSliderOptions")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import breakpoints from "../scripts/breakpoints.js";

export default {
	mixins: [sourceMixin],

	data() {
		return {
			data: null,
			adSliderOptions: {
				slidesPerView: 4,
				spaceBetween: 15,
				breakpoints: {
					[breakpoints['md-min']]: {
						slidesPerView: 4
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 2
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 1
					}
				}
			},
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
};
</script>